import { Link, useNavigate } from "react-router-dom";

import styles from './PageTitleBar.module.css';
import backArrow from "../../assets/icons/BackArrow.svg";

export default function PageTitleBarComponent(props) {
  const navigate = useNavigate();

  return (
    <section className={styles.pageTitleBar + " grid-container"}>
      <Link className={styles.content} onClick={() => navigate(-1)}>
        <img src={backArrow} alt="Back Arrow" className={styles.backArrow} />
        <h1 className={styles.pageTitle}> {props.pageTitle} </h1>
      </Link>
    </section>
  )
}
